import DatePicker from "components/foundation/DatePicker";
import DocumentTextField from "components/foundation/DocumentTextField/DocumentTextField";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import DocumentArrayField from "../../DocumentArrayField";
import { CalculatedFieldResponse } from "models/document/DocumentFieldType";
import CreateDocumentForm from "../../CreateDocumentForm";
import CreateDocumentClassFormBody from "../CreateDocumentClassFormBody";
import { TempDocumentDetailResponseWithAny } from "features/document/hooks/queries/useTempDocumentDetailQuery";
import { EXPENSE_REPORT_FIELD as FIELD } from "config/documentConstant";
import formatMinMaxLengthMessage from "utils/formatUtils/formatMinMaxLengthMessage";

/* 지출결의서 */
interface ExpenseReportForm {
  [FIELD.EXECUTION_PERIOD.key]: string;
  [FIELD.EXPENSE_NOTE.key]: string;
  [FIELD.EXPENSE_DETAILS.key]: {
    description: string;
    amount: string;
    paymentPlace: string;
    paymentAccount: string;
  }[];
  [FIELD.TOTAL_AMOUNT.key]: string;
}

interface ExpenseReportProps {
  tempDocumentDetail?: TempDocumentDetailResponseWithAny;
}

const ExpenseReport = ({ tempDocumentDetail }: ExpenseReportProps) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<ExpenseReportForm>();

  return (
    <CreateDocumentClassFormBody noBorderTop>
      <CreateDocumentForm.Field label={FIELD.EXPENSE_NOTE.label}>
        <DocumentTextField
          {...register(FIELD.EXPENSE_NOTE.key, {
            required: "지출내용 기입 필수",
            minLength: {
              value: FIELD.EXPENSE_NOTE.minLength,
              message: formatMinMaxLengthMessage(
                FIELD.EXPENSE_NOTE.minLength,
                FIELD.EXPENSE_NOTE.maxLength,
              ),
            },
            maxLength: {
              value: FIELD.EXPENSE_NOTE.maxLength,
              message: formatMinMaxLengthMessage(
                FIELD.EXPENSE_NOTE.minLength,
                FIELD.EXPENSE_NOTE.maxLength,
              ),
            },
          })}
          placeholder="지출내용을 입력해 주세요."
          errorMessage={errors[FIELD.EXPENSE_NOTE.key]?.message}
        />
      </CreateDocumentForm.Field>

      <CreateDocumentForm.Field label={FIELD.EXECUTION_PERIOD.label}>
        <Controller
          name={FIELD.EXECUTION_PERIOD.key}
          control={control}
          rules={{
            required: "집행기한 기입 필수",
          }}
          render={({ field }) => (
            <DatePicker
              {...field}
              usage="document"
              placeholder="집행기한을 선택해 주세요."
              defaultValue={
                tempDocumentDetail?.documentData?.[FIELD.EXECUTION_PERIOD.key]
              }
              dateFormat={FIELD.EXECUTION_PERIOD.dateFormat}
              onChangeDate={(_, dateString) => {
                field.onChange(dateString);
              }}
              errorMessage={errors[FIELD.EXECUTION_PERIOD.key]?.message}
            />
          )}
        />
      </CreateDocumentForm.Field>

      <CreateDocumentForm.Field label={FIELD.EXPENSE_DETAILS.label}>
        <DocumentArrayField
          fieldMetaInfo={FIELD.EXPENSE_DETAILS as any}
          sumFieldMetaInfo={FIELD.TOTAL_AMOUNT as CalculatedFieldResponse}
          sumFieldName="amount"
        />
      </CreateDocumentForm.Field>
    </CreateDocumentClassFormBody>
  );
};

export default ExpenseReport;
